import {createContext, useContext} from 'react';
import type {ParticipantView} from '@phonehq/rtc-core';

export interface CallMemberProfile {
    readonly name: string;
    readonly mxcAvatarUrl?: string | null;
}

export type CallMemberDirectory = (userId: string) => CallMemberProfile;

export interface RoomMemberLike {
    readonly name?: string;
    readonly rawDisplayName?: string;
    getMxcAvatarUrl(): string | undefined;
}

export interface RoomWithMembers {
    getMember(userId: string): RoomMemberLike | null;
}

const fallbackDirectory: CallMemberDirectory = userId => ({name: userId});

export const createRoomMemberDirectory = (room: RoomWithMembers | null | undefined): CallMemberDirectory => userId => {
    const member = room?.getMember(userId);
    return {
        name: member?.rawDisplayName || member?.name || userId,
        mxcAvatarUrl: member?.getMxcAvatarUrl() ?? null,
    };
};

export const CallMemberDirectoryContext = createContext<CallMemberDirectory>(fallbackDirectory);

export const useCallMember = (userId: string): CallMemberProfile => useContext(CallMemberDirectoryContext)(userId);

export const ParticipantViewsContext = createContext<ReadonlyMap<string, ParticipantView>>(new Map());

export const useParticipantView = (identity: string | undefined): ParticipantView | undefined => {
    const views = useContext(ParticipantViewsContext);
    return identity ? views.get(identity) : undefined;
};
